import NavigatorStore from "data/NavigatorStore";
import SuperRecordStore from "data/SuperRecordStore";
import TableStore from "data/TableStore";
import EntityName from "data/util/EntityName";
import { superNavTree } from "data/selectors/superRecords";
import { navTree } from "data/selectors/records";
import Dispatcher from "Dispatcher";
import SuperRecordActions from "data/SuperRecordActions";
import ClientId from "data/ClientId";
import RecordActions from "data/RecordActions";
import NavigationActions from "data/NavigationActions";
import React from "react";
import PropTypes from "prop-types";
import HiddenFieldStore from "data/HiddenFieldStore";
import useFluxStore from "@armus/use-flux-store";

const buildNavContainer = (Nav, propsFilter = (raw, contained) => contained) =>
    props => {
        // eslint-disable-next-line react/prop-types
        const {fluxContext: ctx} = props;
        const state = useFluxStore(() => {
            const navState = NavigatorStore.getState(ctx);
            const magicState = navState.magic;
            if (magicState == null) return {gonk: true};
            const isSuperRecord = !EntityName.is(magicState.key);
            let srLO;
            if (isSuperRecord) {
                srLO = SuperRecordStore.getRecordLO(magicState.key, magicState.id);
                if (!srLO.hasValue()) return {gonk: true};
            }
            return propsFilter(props, {
                gonk: false,
                isSuperRecord,
                tree: isSuperRecord
                    ? superNavTree(
                        TableStore,
                        srLO.getRequiredValue(),
                        navState,
                        magicState.key,
                        magicState.id,
                        ctx,
                    )
                    : navTree(
                        TableStore,
                        navState,
                        magicState.key,
                        magicState.id,
                    ),
                onAddMagicChild: (recordKey, recordId, entityKey) =>
                    Dispatcher.contextDispatch(ctx, {
                        type: SuperRecordActions.NEW_MAGIC_CHILD,
                        recordKey,
                        recordId,
                        entityKey,
                        newId: ClientId.next(),
                        navigate: true,
                    }),
                onAddChild: (recordKey, recordId, fieldKey, entityKey) =>
                    Dispatcher.contextDispatch(ctx, {
                        type: RecordActions.NEW_CHILD,
                        recordKey,
                        recordId,
                        fieldKey,
                        entityKey,
                        newId: ClientId.next(),
                        navigate: true,
                    }),
                onDeleteMagicChild: (recordKey, recordId) =>
                    Dispatcher.contextDispatch(ctx, {
                        type: RecordActions.DELETE_RECORD,
                        recordKey,
                        recordId,
                    }),
                onDeleteChild: (recordKey, recordId, fieldKey, childKey, childId) =>
                    Dispatcher.contextDispatch(ctx, {
                        type: RecordActions.DELETE_CHILD,
                        recordKey,
                        recordId,
                        fieldKey,
                        childKey,
                        childId,
                    }),
                onSelectRecord: (entityKey, recordId) =>
                    Dispatcher.contextDispatch(ctx, {
                        type: NavigationActions.SELECT_RECORD,
                        entityKey,
                        recordId,
                    }),
                onSelectImpl: implementationKey =>
                    Dispatcher.contextDispatch(ctx, {
                        type: NavigationActions.SELECT_IMPLEMENTATION,
                        implementationKey,
                    }),
                onSelectAllImpls: () =>
                    Dispatcher.contextDispatch(ctx, {
                        type: NavigationActions.SELECT_ALL_IMPLEMENTATIONS,
                    }),
                onExpansionChange: implementationKey =>
                    Dispatcher.contextDispatch(ctx, {
                        type: NavigationActions.TOGGLE_IMPLEMENTATION,
                        implementationKey,
                    }),
            });
        }, [
            NavigatorStore,
            SuperRecordStore,
            TableStore,
            HiddenFieldStore,
        ], [ctx]);
        return state.gonk ? null : <Nav {...props} {...state} />;
    };

export const navShape = {
    isSuperRecord: PropTypes.bool.isRequired,
    tree: PropTypes.shape({
        name: PropTypes.string.isRequired,
        projections: PropTypes.array.isRequired,
        // various other recursive things....
    }).isRequired,
    onAddMagicChild: PropTypes.func.isRequired,
    onAddChild: PropTypes.func.isRequired,
    onDeleteMagicChild: PropTypes.func.isRequired,
    onDeleteChild: PropTypes.func.isRequired,
    onSelectRecord: PropTypes.func.isRequired,
    onSelectImpl: PropTypes.func.isRequired,
    onSelectAllImpls: PropTypes.func.isRequired,
    onExpansionChange: PropTypes.func.isRequired,
};

export default buildNavContainer;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/views/buildNavContainer.js